import Swiper from "swiper";
import { Pagination } from "swiper/modules";

export const initProductCardBannerSwiper = () => {
  const swiperElement = document.querySelector(".product-card-swiper") as HTMLElement;
  if (!swiperElement) return;

  const swiper = new Swiper(".product-card-swiper", {
    modules: [Pagination],
    spaceBetween: 16,
    slidesPerView: 'auto',
    centeredSlides: false,
    pagination: {
      el: ".product-card-swiper .swiper-pagination",
      clickable: true,
    },
  });
};